import React from 'react';
import { IconButton } from '@fluentui/react/lib/Button';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { ControlIcons } from 'owa-control-icons';
import { fluidLinkFailedCallout } from './CollabSpace.locstring.json';
import { attachmentPolicyInformationBlockedAccess } from 'owa-locstrings/lib/strings/attachmentpolicy.locstring.json';
import loc from 'owa-localize';
import { getViewStateById } from '../selectors/collabSpaceSelectors';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { getIsDarkTheme } from 'owa-fabric-theme';

let styles = require('./ErrorCallout.scss');
let classNames = require('classnames');

export interface ErrorCalloutProps {
    viewStateId: string;
    className?: string;
}

const ErrorCallout = (props: ErrorCalloutProps) => {
    const viewState = getViewStateById(props.viewStateId);
    if (!viewState) {
        return null;
    }

    const fluidLinkFailed = viewState.fluidLinkFailed;

    const fluidLinkFailedIconStyle = getIsDarkTheme()
        ? styles.fluidLinkFailedIconStyleDark
        : styles.fluidLinkFailedIconStyle;

    const style = classNames(
        props.className,
        styles.baseIconStyle,
        fluidLinkFailed ? fluidLinkFailedIconStyle : undefined
    );

    const disclaimerMessage = fluidLinkFailed
        ? fluidLinkFailedCallout
        : attachmentPolicyInformationBlockedAccess;

    const calloutProps = {
        gapSpace: 0,
        isBeakVisible: true,
        directionalHint: DirectionalHint.rightCenter,
        className: styles.errorCalloutStyle,
    };

    return (
        <div className={styles.containerStyle}>
            <TooltipHost content={loc(disclaimerMessage)} calloutProps={calloutProps}>
                <IconButton
                    className={style}
                    iconProps={{ iconName: ControlIcons.Info }}
                    ariaLabel={loc(disclaimerMessage)}
                />
            </TooltipHost>
        </div>
    );
};

export default ErrorCallout;
